module.exports = __webpack_public_path__ + "static/media/tools_01_small.9376d1b3.jpg";